/* Careatic festive product page hero (Arun, 13 Oct 2026), for sections/ca-pdp-festive-hero.liquid.
   Ported from the approved mockup "Careatic Size and Fix Plan".

   Breed first, and nothing is picked for the shopper. Step 1 breed, Step 2 age (or the
   tape for "Other breed? Measure"), then the size card, quantity and Add to Cart. The
   breed and age go with the cart line as the property "Breed". Add to Cart submits the
   form to /cart/add; careatic-cart.js catches that and opens the slide cart.

   The page is updated in place (never redrawn), so the sticky bar and the WhatsApp
   circle never replay their animations when the quantity or the size changes. */
(function () {
  'use strict';
  var PICK_KEY = 'fh-pick';            // this visit's breed, age and quantity (carried across designs)
  var BREED_KEY = 'ca-ethnic-breed';   // shared with the festive collection page
  var html = document.documentElement;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function inr(p) { return '₹' + Math.round(p / 100).toLocaleString('en-IN'); }
  /* MRP (Arun's rule): 20% above the price, rounded up to the next figure ending in 99. Whole rupee maths. */
  function mrpOf(p) { var r = Math.round(p / 100), x = Math.floor((r * 125 + 50) / 100) + 1; return (Math.floor((x + 99) / 100) * 100 - 1) * 100; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function sget(k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function sset(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  function init(root) {
    if (!root || root.hasAttribute('data-fh-ready')) return;
    var D;
    try { D = JSON.parse(root.querySelector('[data-fh-data]').textContent); } catch (e) { return; }
    root.setAttribute('data-fh-ready', '');

    function q(s) { return root.querySelector(s); }
    function qa(s) { return [].slice.call(root.querySelectorAll(s)); }
    var V = D.sizes || {};
    var S = { breed: null, stage: null, measured: null, qty: 1, tab: D.kind, nudge: false };
    var form = q('[data-fh-form]'), atc = q('[data-fh-atc]'), vid = q('[data-fh-vid]'), prop = q('[data-fh-prop]'), qtyIn = q('[data-fh-qty-input]');
    var bar = q('[data-fh-bar]'), barAtc = q('[data-fh-bar-atc]'), barSub = q('[data-fh-bar-sub]');
    var sheet = q('[data-fh-sheet]'), zoom = q('[data-fh-zoom]');
    var sheetOpen = false, zoomOpen = false;

    function breedOf(s) { for (var i = 0; i < D.breeds.length; i++) if (D.breeds[i].s === s) return D.breeds[i]; return null; }
    function sizeOf() {
      if (S.breed === 'other') return S.measured;
      var b = breedOf(S.breed);
      return b && S.stage !== null && b.st[S.stage] ? b.st[S.stage][2] : null;
    }
    function buyable(n) { var v = V[n]; return !!(v && v.a); }
    function outside(n) { return !D.any || n > D.max || n < D.min; }
    function petName(b) { return b.s === 'cat' ? 'cat' : b.n; }

    /* ---------- drawing ---------- */
    function drawPrice() {
      var el = q('[data-fh-price]'); if (!el) return;
      var n = sizeOf(), ok = n && buyable(n), h;
      if (ok || D.lo === D.hi) {
        var p = ok ? V[n].p : D.lo;
        h = '<div class="fh-pr"><span class="fh-price">' + inr(p) + '</span>' +
          (D.mrp ? '<s class="fh-mrp">MRP ' + inr(mrpOf(p)) + '</s><span class="fh-off">20% OFF</span>' : '') + '</div>' +
          '<div class="fh-save">' + (D.mrp ? '<b>Save ' + inr(mrpOf(p) - p) + '</b> · ' : '') + (ok ? 'Size ' + n + ' · ' : '') + 'inclusive of all taxes</div>';
      } else {
        h = '<div class="fh-pr"><span class="fh-price">' + inr(D.lo) + ' to ' + inr(D.hi) + '</span></div>' +
          (D.mrp ? '<div class="fh-pr fh-pr--sub"><s class="fh-mrp">MRP ' + inr(mrpOf(D.lo)) + ' to ' + inr(mrpOf(D.hi)) + '</s><span class="fh-off">20% OFF</span></div>' : '') +
          '<div class="fh-save">' + (D.mrp ? '<b>Save ' + inr(mrpOf(D.lo) - D.lo) + ' to ' + inr(mrpOf(D.hi) - D.hi) + '</b> · ' : '') + 'price depends on size · inclusive of all taxes</div>';
      }
      el.innerHTML = h;
    }

    function drawBreeds() {
      qa('[data-fh-breed]').forEach(function (c) {
        var on = c.getAttribute('data-fh-breed') === S.breed;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-pressed', String(on));
      });
    }

    function stageNote(n) {
      if (buyable(n)) return inr(V[n].p);
      return outside(n) ? 'not in ' + D.kind + 's' : 'sold out';
    }

    function drawStep2() {
      var el = q('[data-fh-step2]'), h;
      if (!S.breed) {
        el.className = 'fh-step2 is-off';
        h = '<b>Step 2 · Age</b><p>Pick a breed first, then I’ll show you my sizes.</p>';
      } else if (S.breed === 'other') {
        el.className = 'fh-step2';
        h = '<b>Step 2 · Your tape</b><p>Measure neck to hip, in inches, and tap your number.</p><div class="fh-tape" role="group" aria-label="Your dog’s length in inches">';
        D.nums.forEach(function (n) {
          h += buyable(n)
            ? '<button type="button" class="fh-size' + (S.measured === n ? ' is-on' : '') + '" data-fh-measure="' + n + '" aria-pressed="' + (S.measured === n) + '"><b>' + n + '</b><small>' + inr(V[n].p) + '</small></button>'
            : '<span class="fh-size is-na"><b>' + n + '</b><small>' + (outside(n) ? 'not made' : 'sold out') + '</small></span>';
        });
        h += '</div>';
      } else {
        var b = breedOf(S.breed);
        el.className = 'fh-step2';
        h = '<b>Step 2 · Age</b><div class="fh-stages" role="group" aria-label="Age">';
        b.st.forEach(function (st, i) {
          var n = st[2], on = S.stage === i;
          h += '<button type="button" class="fh-st' + (buyable(n) ? '' : ' is-na') + (on ? ' is-on' : '') + '" data-fh-stage="' + i + '" aria-pressed="' + on + '"><b>' + esc(st[0]) + '</b><span>' + esc(st[1]) + '</span><small class="fh-st__p">Size ' + n + ' · ' + stageNote(n) + '</small></button>';
        });
        h += '</div>';
      }
      el.innerHTML = h;
    }

    function drawCard() {
      var el = q('[data-fh-card]'), n = sizeOf(), h = '', b = breedOf(S.breed);
      if (n && buyable(n)) {
        var st = b && S.stage !== null ? b.st[S.stage] : null;
        h = '<div class="fh-pick"><div class="fh-pick__badge"><small>SIZE</small><b>' + n + '</b></div><div class="fh-pick__txt"><strong>' +
          (S.breed === 'other' || !st ? 'You measured ' + n + ' inches' : 'Your ' + esc(b.n) + ', ' + esc(st[0].toLowerCase()) + ' (' + esc(st[1]) + ')') +
          '</strong><span>That’s ' + n + ' inches, neck to hip.</span></div></div>';
      } else if (n) {
        var head, tail = '', who = b ? 'Your ' + esc(petName(b)) + ' needs ' + n + '. ' : '';
        if (!D.any) head = 'Coming soon';
        else if (n > D.max) {
          head = D.kindName + 's stop at size ' + D.max;
          if (D.kind === 'lehenga' && D.kmax) tail = 'Kurtas go up to ' + D.kmax + '. <button type="button" data-fh-tab="kurta">See kurtas</button>';
        } else if (n < D.min) {
          head = D.kindName + 's start at size ' + D.min;
          tail = 'Size ' + n + ' is not made in this design yet. WhatsApp us and we will tell you when it is.';
        } else {
          head = 'Size ' + n + ' is sold out in this design';
          tail = 'WhatsApp us and we will tell you when it is back.';
        }
        h = '<div class="fh-pick is-na"><div class="fh-pick__badge"><small>SIZE</small><b>' + n + '</b></div><div class="fh-pick__txt"><strong>' + head + '</strong><span>' + who + tail + '</span></div></div>';
      } else if (S.nudge) {
        h = '<p class="fh-hint is-nudge">' + (S.breed ? (S.breed === 'other' ? 'Now tap your inches.' : 'Now pick the age.') : 'Start with the breed.') +
          ' Not sure? <button type="button" data-fh-act="chart">Open the size chart</button>.</p>';
      }
      el.innerHTML = h;
    }

    function propText(n) {
      if (S.breed === 'other') return 'Measured, ' + n + ' inches';
      var b = breedOf(S.breed), st = b && S.stage !== null ? b.st[S.stage] : null;
      return b && st ? b.n + ', ' + st[0].toLowerCase() : 'Size ' + n;
    }

    function waText() {
      var n = sizeOf(), ok = n && buyable(n), b = breedOf(S.breed), st = b && S.stage !== null ? b.st[S.stage] : null;
      return 'Hi Polie, I am looking at the ' + D.title + (ok ? ', size ' + n : '') +
        (b ? ' for my ' + b.n + (st ? ' (' + st[0].toLowerCase() + ')' : '') : '') + '.';
    }

    function drawBuy() {
      var n = sizeOf(), ok = !!(n && buyable(n)), label, barLabel;
      if (!D.any) label = barLabel = 'Coming soon';
      else if (ok) label = barLabel = (D.prebook ? 'Pre-book · ' : 'Add to Cart · ') + inr(V[n].p * S.qty);
      else if (n) label = barLabel = outside(n) ? 'Not made in size ' + n : 'Sold out in size ' + n;
      else { label = S.breed ? (S.breed === 'other' ? 'Tap your inches' : 'Pick the age') : 'Pick the breed'; barLabel = 'Find the size'; }
      atc.textContent = label;
      atc.type = ok ? 'submit' : 'button';
      atc.classList.toggle('is-empty', !ok && D.any);
      atc.disabled = !D.any;
      if (barAtc) { barAtc.textContent = barLabel; barAtc.classList.toggle('is-empty', !ok && D.any); barAtc.disabled = !D.any; }
      if (barSub) barSub.textContent = ok ? 'Size ' + n + ' · ' + propText(n) : 'Sized by breed';
      vid.value = ok ? V[n].id : ''; vid.disabled = !ok;
      prop.value = ok ? propText(n) : ''; prop.disabled = !ok;
      qtyIn.value = S.qty;
      qa('[data-fh-qval]').forEach(function (e) { e.textContent = S.qty; });
      qa('[data-fh-act="qminus"]').forEach(function (e) { e.disabled = S.qty <= 1; });
      qa('[data-fh-act="qplus"]').forEach(function (e) { e.disabled = S.qty >= 10; });
      var wa = 'https://wa.me/' + D.wa + '?text=' + encodeURIComponent(waText());
      qa('[data-fh-walink]').forEach(function (a) { a.setAttribute('href', wa); });
      qa('[data-fh-measure]').forEach(function (r) {
        if (!r.closest('[data-fh-sheet]')) return;
        r.classList.toggle('is-on', +r.getAttribute('data-fh-measure') === n);
      });
    }

    function drawDesign() {
      qa('[data-fh-tab]').forEach(function (t) {
        if (!t.closest('.fh-seg')) return;
        var on = t.getAttribute('data-fh-tab') === S.tab;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', String(on));
      });
      qa('[data-fh-swrow]').forEach(function (r) { r.hidden = r.getAttribute('data-fh-swrow') !== S.tab; });
      var lbl = q('[data-fh-dlabel]');
      if (lbl) lbl.textContent = S.tab === D.kind ? D.design : 'Pick a ' + S.tab;
      var note = q('[data-fh-gnote]'), n = sizeOf(), b = breedOf(S.breed), h = '', warn = false;
      if (S.tab === 'lehenga' && D.lmax) {
        if (n && n > D.lmax) {
          warn = true;
          h = 'Lehengas stop at size ' + D.lmax + '. ' + (b ? 'Your ' + esc(petName(b)) + ' needs ' + n + '.' : 'You need ' + n + '.') + ' <button type="button" data-fh-tab="kurta">See kurtas</button>';
        } else if (D.kind !== 'lehenga') {
          h = 'Lehengas come in sizes ' + D.lmin + ' to ' + D.lmax + ', ' + inr(D.lplo) + (D.lphi !== D.lplo ? ' to ' + inr(D.lphi) : '') + '. Your breed and age come with you.';
        }
      } else if (S.tab === 'kurta' && D.kind === 'lehenga') {
        h = 'Kurtas come in sizes 10 to ' + (D.kmax || 30) + '. Your breed and age come with you.';
      }
      if (note) { note.innerHTML = h; note.classList.toggle('is-warn', warn); }
    }

    function draw() { drawPrice(); drawBreeds(); drawStep2(); drawCard(); drawBuy(); drawDesign(); if (typeof tick === 'function') tick(); }

    function persist(arrive) { sset(PICK_KEY, { b: S.breed, i: S.stage, m: S.measured, q: S.qty, a: arrive ? 1 : 0 }); }

    /* ---------- scrolling ---------- */
    function scrollToEl(el, gap) {
      if (!el) return;
      var y = el.getBoundingClientRect().top + window.pageYOffset - (gap || 90);
      window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    }

    /* ---------- gallery and zoom ---------- */
    var slides = qa('[data-fh-slide]'), thumbs = qa('[data-fh-th]'), countEl = q('[data-fh-count]'), cur = 0;
    var zimg = q('[data-fh-zimg]'), zcount = q('[data-fh-zcount]'), zhint = q('[data-fh-zhint]');
    var imgIdx = [];
    slides.forEach(function (s, i) { if (s.getAttribute('data-type') === 'image') imgIdx.push(i); });
    /* Desktop shows the photos as a mosaic (one large, two, three); a seventh photo or more puts +N on the sixth tile. */
    var mosaic = window.matchMedia ? window.matchMedia('(min-width: 900px)') : { matches: false };
    if (slides.length > 6) { var more = document.createElement('span'); more.className = 'fh-more'; more.textContent = '+' + (slides.length - 5); slides[5].appendChild(more); }
    function show(i) {
      if (!slides.length) return;
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle('is-on', k === cur);
        var vdo = s.querySelector('video'); if (vdo && k !== cur) { try { vdo.pause(); } catch (e) {} }
      });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-on', k === cur);
        if (k === cur) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      if (countEl) countEl.textContent = (cur + 1) + ' / ' + slides.length;
    }
    function zoomShow() {
      var s = slides[cur]; if (!s || !zimg) return;
      zimg.src = s.getAttribute('data-zoom') || '';
      var im = s.querySelector('img'); zimg.alt = im ? im.alt : '';
      zoom.classList.remove('is-in'); zimg.style.transformOrigin = '50% 50%';
      if (zcount) zcount.textContent = (imgIdx.indexOf(cur) + 1) + ' / ' + imgIdx.length;
      if (zhint) zhint.textContent = 'Tap the photo to zoom in';
    }
    function openZoom() {
      if (!zoom || imgIdx.indexOf(cur) < 0) return;
      zoomOpen = true; zoom.hidden = false; zoomShow(); cover();
      var c = zoom.querySelector('[data-fh-act="unzoom"]'); if (c) c.focus({ preventScroll: true });
    }
    function closeZoom() { if (!zoomOpen) return; zoomOpen = false; zoom.hidden = true; zoom.classList.remove('is-in'); cover(); }
    function zoomStep(d) {
      var at = imgIdx.indexOf(cur); if (at < 0) return;
      show(imgIdx[(at + d + imgIdx.length) % imgIdx.length]); zoomShow();
    }
    function aim(e) {
      if (!zimg) return;
      var r = zimg.getBoundingClientRect(), p = e.touches ? e.touches[0] : e;
      var x = Math.min(100, Math.max(0, ((p.clientX - r.left) / r.width) * 100));
      var y = Math.min(100, Math.max(0, ((p.clientY - r.top) / r.height) * 100));
      zimg.style.transformOrigin = x + '% ' + y + '%';
    }

    /* ---------- size chart sheet ---------- */
    function openSheet() {
      if (!sheet) return;
      sheetOpen = true; sheet.hidden = false; cover(); drawBuy();
      var on = sheet.querySelector('.fh-srow.is-on'), sc = sheet.querySelector('.fh-sheet__scroll');
      if (sc) sc.scrollTop = 0;
      if (on && sc) sc.scrollTop = Math.max(0, on.offsetTop - sc.clientHeight / 2);
    }
    function closeSheet() { if (!sheetOpen) return; sheetOpen = false; sheet.hidden = true; cover(); }

    /* Anything covering the page hides the sticky bar, the circles and the corner video. */
    var mergeSnap = true;
    function cover() {
      var on = sheetOpen || zoomOpen;
      html.classList.toggle('fh-covered', on);
      html.classList.toggle('fh-lock', on);
      if (!on) mergeSnap = true;
      tick();
    }

    /* ---------- sticky bar ---------- */
    function cartOpen() { return html.classList.contains('ca-cd-lock'); }
    function updateBar() {
      if (!bar) return;
      var r = atc.getBoundingClientRect();
      var on = r.bottom < 70 && !sheetOpen && !zoomOpen && !cartOpen();
      if (on !== bar.classList.contains('is-on')) {
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', String(!on));
        document.body.classList.toggle('ca-buybar-open', on);
        html.style.setProperty('--ca-buybar-h', (bar.offsetHeight || 68) + 'px');
      }
    }

    /* ---------- WhatsApp and Instagram circles ---------- */
    var openK = null, tuckT = null;
    function setOpen(k) {
      openK = k;
      qa('[data-fh-dock-item]').forEach(function (it) {
        var on = it.getAttribute('data-fh-dock-item') === k;
        it.classList.toggle('is-out', on);
        var bub = it.querySelector('.fh-bubble'); if (bub) bub.tabIndex = on ? 0 : -1;
      });
      tick();
    }
    function scheduleTuck() { clearTimeout(tuckT); tuckT = setTimeout(function () { setOpen(null); }, 3000); }

    /* Scroll merge (Arun): once the WhatsApp circle passes Step 1 it flies into the small icon on
       "Not sure? Ask Polie on WhatsApp"; just before that line leaves the screen it flies back.
       After landing the fixed circle hides and the inline icon (same look) scrolls with the page,
       so nothing has to chase the scroll. */
    var waItem = q('[data-fh-dock-item="wa"]'), dockEl = q('[data-fh-dock]'), dot = q('[data-fh-wadot]'), step1 = q('[data-fh-step1]');
    var merged = false, landed = false, mergeT = null;
    var EASE = 'transform .45s cubic-bezier(.2,.8,.2,1)';
    function land() { landed = true; root.classList.remove('is-merging'); root.classList.add('is-merged'); waItem.style.transition = 'none'; waItem.style.transform = ''; }
    function merge() {
      if (!waItem || !dockEl || !dot || !step1) return;
      var covered = sheetOpen || zoomOpen || cartOpen();
      var dk = dockEl.getBoundingClientRect(), d = dot.getBoundingClientRect(), s1 = step1.getBoundingClientRect();
      var cw = waItem.offsetWidth || 35, sx = dk.right - cw / 2, sy = dk.top + waItem.offsetTop + (waItem.offsetHeight || 35) / 2;
      var barH = bar && bar.classList.contains('is-on') ? bar.offsetHeight : 0;
      var dotOn = d.width > 0 && d.top > 70 && d.bottom < window.innerHeight - barH - 10;
      var want = !openK && !covered && s1.top < sy && dotOn;
      var tf = 'translate(' + (d.left + d.width / 2 - sx) + 'px,' + (d.top + d.height / 2 - sy) + 'px) scale(' + (d.width / cw) + ')';
      if (want) {
        if (!merged) {
          merged = true; clearTimeout(mergeT);
          if (mergeSnap || reduce) land();
          else {
            root.classList.add('is-merging');
            waItem.style.transition = EASE; waItem.style.transform = tf;
            mergeT = setTimeout(land, 460);
          }
        } else if (!landed) waItem.style.transform = tf; // keep aiming while it flies
      } else if (merged) {
        var wasLanded = landed;
        merged = false; landed = false; clearTimeout(mergeT);
        if (wasLanded && !covered && !reduce) { waItem.style.transition = 'none'; waItem.style.transform = tf; }
        root.classList.remove('is-merging', 'is-merged');
        void waItem.offsetWidth;
        waItem.style.transition = covered || reduce ? 'none' : EASE;
        waItem.style.transform = '';
        mergeT = setTimeout(function () { waItem.style.transition = ''; }, 460);
      }
      mergeSnap = false;
    }

    /* Never on top of a button: while a tucked circle would sit on a breed, age or size button
       (narrow phones), it slides further in and lets the tap through to the button. The check uses
       the circle's resting place, so it does not flicker. */
    var dockItems = qa('[data-fh-dock-item]');
    function shy() {
      if (!dockEl) return;
      var dk = dockEl.getBoundingClientRect(), over = false;
      var hits = qa('[data-fh-breed],[data-fh-stage],.fh-zone [data-fh-measure],.fh-qtyrow button,[data-fh-atc],.fh-chartlink,.fh-swb');
      dockItems.forEach(function (it) {
        if (over || it.classList.contains('is-out')) return;
        var w = it.offsetWidth || 35, top = dk.top + it.offsetTop, L = dk.right - w + 19, R = dk.right + 19;
        for (var i = 0; i < hits.length && !over; i++) {
          var b = hits[i].getBoundingClientRect();
          if (b.width && b.right > L && b.left < R && b.bottom > top && b.top < top + w) over = true;
        }
      });
      root.classList.toggle('is-shy', over);
    }

    var ticking = false;
    function tick() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; updateBar(); merge(); shy(); });
    }
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick, { passive: true });
    if ('MutationObserver' in window) {
      var wasCart = cartOpen();
      new MutationObserver(function () {
        var c = cartOpen();
        if (c !== wasCart) { wasCart = c; if (!c) mergeSnap = true; tick(); }
      }).observe(html, { attributes: true, attributeFilter: ['class'] });
    }
    /* The corner video stays hidden while the size steps are on screen. */
    var zone = q('[data-fh-zone]');
    if (zone && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { html.classList.toggle('fh-sizes-on', en.isIntersecting); });
      }, { rootMargin: '-40px 0px -40px 0px' }).observe(zone);
    }

    /* ---------- taps ---------- */
    var photo = q('[data-fh-photo]'), tx = null, ty = null, swiped = false;
    if (photo && slides.length > 1) {
      photo.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; swiped = false; }, { passive: true });
      photo.addEventListener('touchend', function (e) {
        if (tx === null) return;
        var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { swiped = true; show(dx < 0 ? cur + 1 : cur - 1); }
        tx = null;
      }, { passive: true });
    }
    var zstage = q('[data-fh-zstage]'), zx = null, zy = null;
    if (zstage) {
      zstage.addEventListener('touchstart', function (e) { zx = e.touches[0].clientX; zy = e.touches[0].clientY; }, { passive: true });
      zstage.addEventListener('touchmove', function (e) { if (zoom.classList.contains('is-in')) aim(e); }, { passive: true });
      zstage.addEventListener('touchend', function (e) {
        if (zx === null) return;
        var dx = e.changedTouches[0].clientX - zx, dy = e.changedTouches[0].clientY - zy;
        if (!zoom.classList.contains('is-in') && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { zoomStep(dx < 0 ? 1 : -1); zx = null; e.preventDefault(); return; }
        zx = null;
      });
      zstage.addEventListener('mousemove', function (e) { if (zoom.classList.contains('is-in')) aim(e); });
      zstage.addEventListener('click', function (e) {
        if (!zoom.classList.contains('is-in')) aim(e);
        var inNow = zoom.classList.toggle('is-in');
        if (zhint) zhint.textContent = inNow ? 'Tap again to zoom out' : 'Tap the photo to zoom in';
      });
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-fh-breed],[data-fh-stage],[data-fh-measure],[data-fh-tab],[data-fh-act],[data-fh-th],[data-fh-go],[data-fh-dock],[data-fh-photo],[data-fh-bar-atc],[data-fh-atc]');
      if (!t || !root.contains(t)) {
        if (sheetOpen && e.target === sheet) closeSheet();
        return;
      }
      if (t.hasAttribute('data-fh-th')) { show(+t.getAttribute('data-fh-th')); return; }
      if (t.hasAttribute('data-fh-photo')) {
        if (swiped) { swiped = false; return; }
        var tile = e.target.closest('[data-fh-slide]');
        if (mosaic.matches && tile) show(slides.indexOf(tile));
        openZoom(); return;
      }
      if (t.hasAttribute('data-fh-go')) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
        if (t.getAttribute('aria-current') === 'page') { e.preventDefault(); return; }
        persist(true);
        if (!reduce) root.classList.add('is-swapping');
        return; // the link opens the next design; breed, age and quantity come along
      }
      if (t.hasAttribute('data-fh-dock')) {
        var k = t.getAttribute('data-fh-dock');
        if (openK !== k) { e.preventDefault(); setOpen(k); scheduleTuck(); }
        else scheduleTuck(); // second tap: the link opens WhatsApp or Instagram
        return;
      }
      if (t.hasAttribute('data-fh-tab')) {
        S.tab = t.getAttribute('data-fh-tab'); drawDesign();
        if (!t.closest('.fh-seg')) scrollToEl(q('[data-fh-design]'), 100);
        return;
      }
      if (t.hasAttribute('data-fh-breed')) {
        var v = t.getAttribute('data-fh-breed');
        if (v !== S.breed) { S.breed = v; S.stage = null; S.measured = null; }
        S.nudge = false;
        if (v !== 'other') { try { localStorage.setItem(BREED_KEY, v); } catch (er) {} }
        persist(); draw(); return;
      }
      if (t.hasAttribute('data-fh-stage')) { S.stage = +t.getAttribute('data-fh-stage'); S.nudge = false; persist(); draw(); return; }
      if (t.hasAttribute('data-fh-measure')) {
        var n = +t.getAttribute('data-fh-measure'), fromSheet = !!t.closest('[data-fh-sheet]');
        var b = S.breed && S.breed !== 'other' ? breedOf(S.breed) : null, idx = -1;
        if (b) b.st.forEach(function (st, i) { if (st[2] === n) idx = i; });
        if (idx >= 0) S.stage = idx; else { S.breed = 'other'; S.measured = n; S.stage = null; }
        S.nudge = false; persist(); draw();
        if (fromSheet) { closeSheet(); scrollToEl(q('[data-fh-card]'), 160); }
        return;
      }
      if (t.hasAttribute('data-fh-atc') || t.hasAttribute('data-fh-bar-atc')) {
        var size = sizeOf();
        if (!D.any) return;
        if (size && buyable(size)) {
          if (t.hasAttribute('data-fh-bar-atc')) { e.preventDefault(); if (form.requestSubmit) form.requestSubmit(atc); else atc.click(); }
          return; // the main button is a real submit; careatic-cart.js takes it from here
        }
        e.preventDefault();
        S.nudge = true; drawCard();
        scrollToEl(q(S.breed ? '[data-fh-step2]' : '[data-fh-step1]'), 90);
        return;
      }
      var act = t.getAttribute('data-fh-act');
      if (act === 'qminus' || act === 'qplus') { S.qty = Math.max(1, Math.min(10, S.qty + (act === 'qplus' ? 1 : -1))); persist(); drawBuy(); }
      else if (act === 'chart') openSheet();
      else if (act === 'close') closeSheet();
      else if (act === 'unzoom') closeZoom();
      else if (act === 'prev') zoomStep(-1);
      else if (act === 'next') zoomStep(1);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeZoom(); closeSheet(); }
      else if (zoomOpen && e.key === 'ArrowLeft') zoomStep(-1);
      else if (zoomOpen && e.key === 'ArrowRight') zoomStep(1);
    });

    form.addEventListener('submit', function () {
      var n = sizeOf();
      persist();
      if (window.caTrack && n && V[n]) window.caTrack('add_to_cart', { size: n, quantity: S.qty, value: Math.round(V[n].p * S.qty / 100) });
    }, true);

    window.addEventListener('pageshow', function (e) { if (e.persisted) root.classList.remove('is-swapping'); });

    /* ---------- start: this visit's own pick, or a ?breed= link. Nothing else is preselected. ---------- */
    var saved = sget(PICK_KEY), arriving = false, param = null;
    try { param = new URL(window.location.href).searchParams.get('breed'); } catch (e) {}
    if (saved && (saved.b === 'other' || breedOf(saved.b))) {
      S.breed = saved.b;
      S.stage = typeof saved.i === 'number' ? saved.i : null;
      S.measured = typeof saved.m === 'number' ? saved.m : null;
      if (saved.a) { arriving = true; S.qty = Math.max(1, Math.min(10, saved.q || 1)); }
    }
    if (param && breedOf(param) && param !== S.breed) { S.breed = param; S.stage = null; S.measured = null; }
    if (S.stage !== null) { var sb = breedOf(S.breed); if (!sb || !sb.st[S.stage]) S.stage = null; }
    if (arriving) {
      persist(false);
      if (!reduce) { root.classList.add('is-arriving'); setTimeout(function () { root.classList.remove('is-arriving'); }, 800); }
    }
    draw();
    tick();
    if (window.caTrack) window.caTrack('view_item', { item_name: D.title });
  }

  function boot() { [].slice.call(document.querySelectorAll('[data-fh]')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector('[data-fh]'); if (r) init(r); });
})();
